import { jsPDF } from "jspdf";
import { getBarcodeBySku, applyPriceCode, formatNormalPrice } from "../helpers/barcodeHelper";
import { _Api } from "components/api/_call";
import { dataListExample } from "./dataListExample";
import { formatWeightValue, getPrintPieceCount } from "./printQuantity";

const getStoneY = (customTemplateConfig, fieldName, lineSpace, index) => (
  lineSpace * (index + 1) + (customTemplateConfig.stone_data[fieldName]?.position.y || 0)
);

const getCustomTemplateFontSize = (customTemplateConfig, fieldName, fallback = 6) => {
  const fieldConfig = customTemplateConfig?.stone_data?.[fieldName]
    || customTemplateConfig?.[fieldName];
  const groupSize = Number(customTemplateConfig?.stone_data?.font_size);
  const configuredSize = Number(fieldConfig?.font_size);
  if (Number.isFinite(configuredSize) && configuredSize > 0) {
    return configuredSize;
  }
  return Number.isFinite(groupSize) && groupSize > 0 && customTemplateConfig?.stone_data?.[fieldName]
    ? groupSize
    : fallback;
};

const setCustomTemplateFontSize = (doc, customTemplateConfig, fieldName, fallback = 6) => {
  doc.setFontSize(getCustomTemplateFontSize(customTemplateConfig, fieldName, fallback));
};


export const CustomTemplateExample = async (config = {}, customTemplateConfig) => {
  let barcode = await _Api({ barcodedata: ["SB03218KYGDM-45"], dataType: "sku" }, "api/v1/barcode/create")
  // let barcode = barcodeData.data

  let dataList = dataListExample

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }


  const fontSizeStoneBylength = {
    "2": 5,
    "3": 4,
    "4": 3,
    "5": 3
  }

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [75, 13]
  });

  // console.log(InventoryList,'InventoryList')
  dataList.map((v, k) => {
    console.log(v.stock_id, 'vmap')

    doc.setFont('helvetica', 'bold');

    setCustomTemplateFontSize(doc, customTemplateConfig, 'sku', 6);
    doc.text(v.SKU, customTemplateConfig.sku.position.x, customTemplateConfig.sku.position.y, 0);

    const collectionPosition = customTemplateConfig.collection?.position || {
      x: customTemplateConfig.sku.position.x,
      y: customTemplateConfig.sku.position.y + 0.7
    };
    const collectionText = config.collection === true
      ? (v.collection_code || v.collection_name)
      : "";
    if (collectionText) {
      setCustomTemplateFontSize(doc, customTemplateConfig, 'collection', 4);
      doc.text(collectionText, collectionPosition.x, collectionPosition.y, 0);
    }
    const barcodeY = customTemplateConfig.barcode.position.y;

    doc.setFontSize('10');


    if (config.barcode === true) {

      doc.addImage(getBarcodeBySku(barcode.data, v.SKU), 'PNG', customTemplateConfig.barcode.position.x, barcodeY, customTemplateConfig.barcode.size.width, customTemplateConfig.barcode.size.height, null, "SLOW");

    }

    // doc.addFont('ComicSansMS', 'Comic Sans', 'normal','StandardEncoding');

    setCustomTemplateFontSize(doc, customTemplateConfig, 'stock_id', 6);
    doc.setFont('helvetica', 'bold');


    // Remove the currency symbol and commas



    if (config.stock_id !== false) {
      doc.text(v.stock_id, customTemplateConfig.stock_id.position.x, customTemplateConfig.stock_id.position.y, 0);
    }

    if (config.metal === true) {
      if (v.metal_code) {
        setCustomTemplateFontSize(doc, customTemplateConfig, 'metal', 6);
        doc.text(v.metal_code, customTemplateConfig.metal.position.x, customTemplateConfig.metal.position.y, 0);

      }
    }


    let numericString;
    if (isNaN(v.price)) {
      numericString = v.price.replace(/[^0-9.]/g, '');
    } else {
      numericString = v.price;
    }

    if (config.price === true) {

      if (v.price) {

        if (config.price_display === "with_currency") {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'price', 6);
          if (isNaN(numericString)) {
            doc.text(formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          } else {
            console.log('else esle')
            doc.text(formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          }

        } else {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'price', 6);
          if (isNaN(numericString)) {
            doc.text(applyPriceCode(numberWithCommas(numericString), config, v), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          } else {
            doc.text(applyPriceCode(numberWithCommas(parseFloat(numericString).toFixed(2)), config, v), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          }
        }



      }


    }
    const nwt = formatWeightValue(v.NetWt) + "g"
    const gwt = formatWeightValue(v.GrossWt) + "g"
    const showPieceCount = config.pcs !== false;
    const pieceText = `${getPrintPieceCount(v)}p`;

    if (config.weight === true) {
      const weightFontSize = getCustomTemplateFontSize(customTemplateConfig, 'weight', 6);
      doc.setFontSize(weightFontSize);
      if (config.weight_display === "nwt") {
        const weightTextPosition = customTemplateConfig.weight.position;
        const weightTextWidth = doc.getTextWidth(nwt);
        doc.text(nwt, weightTextPosition.x, weightTextPosition.y, 0);
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( nwt, 47 ,12, 0);

      } else {
        const weightTextPosition = customTemplateConfig.weight.position;
        const weightTextWidth = doc.getTextWidth(gwt);
        doc.text(gwt, weightTextPosition.x, weightTextPosition.y, 0); //for no currency layout
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( gwt, 47 ,12, 0);

      }
    }

    if (config.text === true && config.text_message) {
      setCustomTemplateFontSize(doc, customTemplateConfig, 'text', 6);
      doc.text(
        config.text_message,
        customTemplateConfig.text.position.x,
        customTemplateConfig.text.position.y,
        0
      );
    }

    function checkType(value) {
      if (Array.isArray(value)) {
        return "Array";
      } else if (typeof value === "object" && value !== null) {
        return "Object";
      } else {
        return "Neither Object nor Array";
      }
    }
    let stone_list;
    if (checkType(v.Stones_Data) === "Array") {
      stone_list = v.Stones_Data.slice()
    } else {
      stone_list = []
      stone_list.push(v.Stones_Data)
    }
    console.log(stone_list, 'stone_list')
    let list_stone = {};

    stone_list.map((v, k, arr) => {

      // const key = `${config.stone_name&&v.stone_details._id?v.stone_details._id:"no_sc"}_${config.stone_group&&v.stone_group_details._id?v.stone_group_details._id:"no_sg"}_${config.clarity&&v.stone_clarity_details._id?v.stone_clarity_details._id:"no_clar"}_${config.shape&&v.stone_shape_details._id?v.stone_shape_details._id:"no_sh"}`;
      const key = `${config.stone_name && v.stone_details ? v.stone_details._id : "no_sc"}_${config.stone_group && v.stone_group_details ? v.stone_group_details._id : "no_sg"}_${config.clarity && v.stone_clarity_details ? v.stone_clarity_details._id : "no_clar"}_${config.shape && v.stone_shape_details?._id ? v.stone_shape_details._id : "no_sh"}_${config.cut && v.stone_cut_details ? v.stone_cut_details._id : "no_cut"}_${config.color && v.stone_color_details ? v.stone_color_details._id : ""}_${config.stone_size && v.stone_size_details ? v.stone_size_details._id : ""}`;

      if (!list_stone[key]) {

        list_stone[key] = { ...v };
      } else {
        console.log(list_stone, 'else ees')
        // console.log(merged[key],' merged[key]')
        // console.log(merged[key].Cts,' merged[key].Cts')
        // console.log(stone.Cts,' stone.Cts')
        list_stone[key].Cts = parseFloat(parseFloat(list_stone[key].Cts) + parseFloat(v.Cts)).toFixed(2);
        list_stone[key].Pcs = parseInt(list_stone[key].Pcs) + parseInt(v.Pcs);

      }

      return true;

    })
    const stone_merge_array = Object.values(list_stone).map(stone => ({
      ...stone,

    }));
    const previewStoneCount = Number(config.preview_stone_count);
    const stonesToRender = Number.isFinite(previewStoneCount) && previewStoneCount > 0 && stone_list.length > 0
      ? Array.from(
        { length: Math.floor(previewStoneCount) },
        (_, index) => stone_list[index % stone_list.length]
      )
      : stone_merge_array;

    stonesToRender.map((v, k, arr) => {

      if (v.stone_details?.code) {
        if ((v.stone_details.code.length) >= (v.stone_shape_details?.code?.length || 0)) {
          doc.setFontSize(fontSizeStoneBylength[v.stone_details.code.length])
        } else {
          doc.setFontSize(fontSizeStoneBylength[v.stone_shape_details.code.length]);
        }
      }
      const stoneDefaultFontSize = doc.getFontSize();

      let space = customTemplateConfig.stone_data.line_space_offset;
      // const text = v.stone_code+" "+v.shape_code+" "+" "+v.Pcs+" "+v.Cts;

      if (config.stone_name === true) {
        if (config.stone_group === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
          doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);

          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_group', stoneDefaultFontSize);
          doc.text(v.stone_group_details?.code || "", customTemplateConfig.stone_data.stone_group.position.x, getStoneY(customTemplateConfig, 'stone_group', space, k), 0);

        } else {
          if (config.clarity === false) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
            doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);

          }

        }

      } else {
        if (config.clarity === false) {
          if (config.stone_group === true) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_group', stoneDefaultFontSize);
            doc.text(v.stone_group_details?.code || "", customTemplateConfig.stone_data.stone_group.position.x, getStoneY(customTemplateConfig, 'stone_group', space, k), 0);

          }
        }
      }

      if (config.stone_group === true && config.stone_name === false) {

        setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
        doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);



      }




      if (config.clarity === true && config.stone_group === false && config.stone_name === false) {
        if (v.clarity) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'clarity', stoneDefaultFontSize);
          doc.text(v.stone_clarity_details?.code || "", customTemplateConfig.stone_data.clarity.position.x, getStoneY(customTemplateConfig, 'clarity', space, k),);


        }

      }

      if (v.shape) {
        if (config.shape === true) {
          if (config.clarity === true) {

            setCustomTemplateFontSize(doc, customTemplateConfig, 'shape', stoneDefaultFontSize);
            doc.text(v.stone_shape_details?.code || "", customTemplateConfig.stone_data.shape.position.x, getStoneY(customTemplateConfig, 'shape', space, k),);

          }
        }
        if (config.stone_group === false && config.stone_name === false) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'shape', stoneDefaultFontSize);
          doc.text(v.stone_shape_details?.code || "", customTemplateConfig.stone_data.shape.position.x, getStoneY(customTemplateConfig, 'shape', space, k),);
        }
      }


      if (v.color) {
        if (config.color === true) {
          if (v.stone_color_details) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'color', stoneDefaultFontSize);
            doc.text(v.stone_color_details?.code || "", customTemplateConfig.stone_data.color.position.x, getStoneY(customTemplateConfig, 'color', space, k),);

          }

        }
      }


      if (v.Cut) {
        if (config.cut === true) {
          if (v.stone_cut_details) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'cut', stoneDefaultFontSize);
            doc.text(v.stone_cut_details?.code || "", customTemplateConfig.stone_data.cut.position.x, getStoneY(customTemplateConfig, 'cut', space, k),);

          }
        }
      }



      if (v.Size) {
        if (config.stone_size === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_size', stoneDefaultFontSize);
          doc.text(
            v.stone_size_details?.code || v.size_name || "",
            customTemplateConfig.stone_data.stone_size.position.x,
            getStoneY(customTemplateConfig, 'stone_size', space, k),
          );
        }

      }

      if (v.Pcs) {

        if (config.stone_pcs === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_pcs', stoneDefaultFontSize);
          doc.text(v.Pcs.toString(), customTemplateConfig.stone_data.stone_pcs.position.x, getStoneY(customTemplateConfig, 'stone_pcs', space, k));

        }

      }

      if (config.stone_weight === true) {

        setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_weight', stoneDefaultFontSize);
        doc.text(v.Cts.toString() + (v.Unit ? v.Unit.substring(0, 1).toLowerCase() : ""), customTemplateConfig.stone_data.stone_weight.position.x, getStoneY(customTemplateConfig, 'stone_weight', space, k),);

      }
      return true;

    })

    if (k + 1 < dataList.length) {
      doc.addPage();

    }
    return true;

  })
  return doc.output('datauristring');
  //   switch (returnType) {
  //     case "save":
  //       return doc.save("barcode.pdf");

  //     case "uri":
  //       return doc.output('datauristring');

  //     case "printout":
  //       doc.autoPrint({ variant: 'non-conform' })
  //       return doc.output('dataurlnewwindow');
  //       // return doc.addJS('print({});');



  //     default:
  //       return doc.save("barcode.pdf");
  //   }


}

export const CustomTemplate = async (barcode, dataList, qrcodedata, qrcode = "offline", config = {}, returnType = "save", customTemplateConfig) => {


  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  console.log(dataList)
  const fontSizeStoneBylength = {
    "2": 5,
    "3": 4,
    "4": 3,
    "5": 3
  }

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [75, 13]
  });

  // console.log(InventoryList,'InventoryList')
  dataList.map((v, k) => {
    console.log(v.stock_id, 'vmap')

    doc.setFont('helvetica', 'bold');

    setCustomTemplateFontSize(doc, customTemplateConfig, 'sku', 6);
    doc.text(v.SKU, customTemplateConfig.sku.position.x, customTemplateConfig.sku.position.y, 0);

    const collectionPosition = customTemplateConfig.collection?.position || {
      x: customTemplateConfig.sku.position.x,
      y: customTemplateConfig.sku.position.y + 0.7
    };
    const collectionText = config.collection === true
      ? (v.collection_code || v.collection_name)
      : "";
    if (collectionText) {
      setCustomTemplateFontSize(doc, customTemplateConfig, 'collection', 4);
      doc.text(collectionText, collectionPosition.x, collectionPosition.y, 0);
    }
    const barcodeY = customTemplateConfig.barcode.position.y;

    doc.setFontSize('10');


    if (config.barcode === true) {

      doc.addImage(getBarcodeBySku(barcode.data, v.SKU), 'PNG', customTemplateConfig.barcode.position.x, barcodeY, customTemplateConfig.barcode.size.width, customTemplateConfig.barcode.size.height, null, "SLOW");

    }

    // doc.addFont('ComicSansMS', 'Comic Sans', 'normal','StandardEncoding');

    setCustomTemplateFontSize(doc, customTemplateConfig, 'stock_id', 6);
    doc.setFont('helvetica', 'bold');


    // Remove the currency symbol and commas



    if (config.stock_id !== false) {
      doc.text(v.stock_id, customTemplateConfig.stock_id.position.x, customTemplateConfig.stock_id.position.y, 0);
    }

    if (config.metal === true) {
      if (v.metal_code) {
        setCustomTemplateFontSize(doc, customTemplateConfig, 'metal', 6);
        doc.text(v.metal_code, customTemplateConfig.metal.position.x, customTemplateConfig.metal.position.y, 0);

      }
    }


    let numericString;
    if (isNaN(v.price)) {
      numericString = v.price.replace(/[^0-9.]/g, '');
    } else {
      numericString = v.price;
    }

    if (config.price === true) {

      if (v.price) {

        if (config.price_display === "with_currency") {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'price', 6);
          if (isNaN(numericString)) {
            doc.text(formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          } else {
            console.log('else esle')
            doc.text(formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          }

        } else {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'price', 6);
          if (isNaN(numericString)) {
            doc.text(applyPriceCode(numberWithCommas(numericString), config, v), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          } else {
            doc.text(applyPriceCode(numberWithCommas(parseFloat(numericString).toFixed(2)), config, v), customTemplateConfig.price.position.x, customTemplateConfig.price.position.y, 0);

          }
        }



      }


    }
    const nwt = formatWeightValue(v.NetWt) + "g"
    const gwt = formatWeightValue(v.GrossWt) + "g"
    const showPieceCount = config.pcs !== false;
    const pieceText = `${getPrintPieceCount(v)}p`;

    if (config.weight === true) {
      const weightFontSize = getCustomTemplateFontSize(customTemplateConfig, 'weight', 6);
      doc.setFontSize(weightFontSize);
      if (config.weight_display === "nwt") {
        const weightTextPosition = customTemplateConfig.weight.position;
        const weightTextWidth = doc.getTextWidth(nwt);
        doc.text(nwt, weightTextPosition.x, weightTextPosition.y, 0);
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( nwt, 47 ,12, 0);

      } else {
        const weightTextPosition = customTemplateConfig.weight.position;
        const weightTextWidth = doc.getTextWidth(gwt);
        doc.text(gwt, weightTextPosition.x, weightTextPosition.y, 0); //for no currency layout
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( gwt, 47 ,12, 0);

      }
    }

    if (config.text === true && config.text_message) {
      setCustomTemplateFontSize(doc, customTemplateConfig, 'text', 6);
      doc.text(
        config.text_message,
        customTemplateConfig.text.position.x,
        customTemplateConfig.text.position.y,
        0
      );
    }

    function checkType(value) {
      if (Array.isArray(value)) {
        return "Array";
      } else if (typeof value === "object" && value !== null) {
        return "Object";
      } else {
        return "Neither Object nor Array";
      }
    }
    let stone_list;
    if (checkType(v.Stones_Data) === "Array") {
      stone_list = v.Stones_Data
    } else {
      stone_list = []
      stone_list.push(v.Stones_Data)
    }
    console.log(stone_list, 'stone_list')
    let list_stone = {};

    stone_list.map((v, k, arr) => {

      // const key = `${config.stone_name&&v.stone_details._id?v.stone_details._id:"no_sc"}_${config.stone_group&&v.stone_group_details._id?v.stone_group_details._id:"no_sg"}_${config.clarity&&v.stone_clarity_details._id?v.stone_clarity_details._id:"no_clar"}_${config.shape&&v.stone_shape_details._id?v.stone_shape_details._id:"no_sh"}`;
      const key = `${config.stone_name && v.stone_details ? v.stone_details._id : "no_sc"}_${config.stone_group && v.stone_group_details ? v.stone_group_details._id : "no_sg"}_${config.clarity && v.stone_clarity_details ? v.stone_clarity_details._id : "no_clar"}_${config.shape && v.stone_shape_details?._id ? v.stone_shape_details._id : "no_sh"}_${config.cut && v.stone_cut_details ? v.stone_cut_details._id : "no_cut"}_${config.color && v.stone_color_details ? v.stone_color_details._id : ""}_${config.stone_size && v.stone_size_details ? v.stone_size_details._id : ""}`;

      if (!list_stone[key]) {

        list_stone[key] = { ...v };
      } else {
        console.log(list_stone, 'else ees')
        // console.log(merged[key],' merged[key]')
        // console.log(merged[key].Cts,' merged[key].Cts')
        // console.log(stone.Cts,' stone.Cts')
        list_stone[key].Cts = parseFloat(parseFloat(list_stone[key].Cts) + parseFloat(v.Cts)).toFixed(2);
        list_stone[key].Pcs = parseInt(list_stone[key].Pcs) + parseInt(v.Pcs);

      }


      return true;

    })
    const stone_merge_array = Object.values(list_stone).map(stone => ({
      ...stone,

    }));

    stone_merge_array.map((v, k, arr) => {

      if (v.stone_details?.code) {
        if ((v.stone_details.code.length) >= (v.stone_shape_details?.code?.length || 0)) {
          doc.setFontSize(fontSizeStoneBylength[v.stone_details.code.length])
        } else {
          doc.setFontSize(fontSizeStoneBylength[v.stone_shape_details.code.length]);
        }
      }
      const stoneDefaultFontSize = doc.getFontSize();

      let space = customTemplateConfig.stone_data.line_space_offset;
      // const text = v.stone_code+" "+v.shape_code+" "+" "+v.Pcs+" "+v.Cts;

      if (config.stone_name === true) {
        if (config.stone_group === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
          doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);

          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_group', stoneDefaultFontSize);
          doc.text(v.stone_group_details?.code || "", customTemplateConfig.stone_data.stone_group.position.x, getStoneY(customTemplateConfig, 'stone_group', space, k), 0);

        } else {
          if (config.clarity === false) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
            doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);

          }

        }

      } else {
        if (config.clarity === false) {
          if (config.stone_group === true) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_group', stoneDefaultFontSize);
            doc.text(v.stone_group_details?.code || "", customTemplateConfig.stone_data.stone_group.position.x, getStoneY(customTemplateConfig, 'stone_group', space, k), 0);

          }
        }
      }

      if (config.stone_group === true && config.stone_name === false) {

        setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_name', stoneDefaultFontSize);
        doc.text(v.stone_details?.code || "", customTemplateConfig.stone_data.stone_name.position.x, getStoneY(customTemplateConfig, 'stone_name', space, k), 0);



      }




      if (config.clarity === true && config.stone_group === false && config.stone_name === false) {
        if (v.clarity) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'clarity', stoneDefaultFontSize);
          doc.text(v.stone_clarity_details?.code || "", customTemplateConfig.stone_data.clarity.position.x, getStoneY(customTemplateConfig, 'clarity', space, k),);


        }

      }

      if (v.shape) {
        if (config.shape === true) {
          if (config.clarity === true) {

            setCustomTemplateFontSize(doc, customTemplateConfig, 'shape', stoneDefaultFontSize);
            doc.text(v.stone_shape_details?.code || "", customTemplateConfig.stone_data.shape.position.x, getStoneY(customTemplateConfig, 'shape', space, k),);

          }
        }
        if (config.stone_group === false && config.stone_name === false) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'shape', stoneDefaultFontSize);
          doc.text(v.stone_shape_details?.code || "", customTemplateConfig.stone_data.shape.position.x, getStoneY(customTemplateConfig, 'shape', space, k),);
        }
      }


      if (v.color) {
        if (config.color === true) {
          if (v.stone_color_details) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'color', stoneDefaultFontSize);
            doc.text(v.stone_color_details?.code || "", customTemplateConfig.stone_data.color.position.x, getStoneY(customTemplateConfig, 'color', space, k),);

          }

        }
      }


      if (v.Cut) {
        if (config.cut === true) {
          if (v.stone_cut_details) {
            setCustomTemplateFontSize(doc, customTemplateConfig, 'cut', stoneDefaultFontSize);
            doc.text(v.stone_cut_details?.code || "", customTemplateConfig.stone_data.cut.position.x, getStoneY(customTemplateConfig, 'cut', space, k),);

          }
        }
      }



      if (v.Size) {
        if (config.stone_size === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_size', stoneDefaultFontSize);
          doc.text(
            v.stone_size_details?.code || v.size_name || "",
            customTemplateConfig.stone_data.stone_size.position.x,
            getStoneY(customTemplateConfig, 'stone_size', space, k),
          );
        }

      }

      if (v.Pcs) {

        if (config.stone_pcs === true) {
          setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_pcs', stoneDefaultFontSize);
          doc.text(v.Pcs.toString(), customTemplateConfig.stone_data.stone_pcs.position.x, getStoneY(customTemplateConfig, 'stone_pcs', space, k));

        }

      }

      if (config.stone_weight === true) {

        setCustomTemplateFontSize(doc, customTemplateConfig, 'stone_weight', stoneDefaultFontSize);
        doc.text(v.Cts.toString() + (v.Unit ? v.Unit.substring(0, 1).toLowerCase() : ""), customTemplateConfig.stone_data.stone_weight.position.x, getStoneY(customTemplateConfig, 'stone_weight', space, k),);

      }

      return true;

    })

    if (k + 1 < dataList.length) {
      doc.addPage();

    }
    return true;
  })


  switch (returnType) {
    case "save":
      return doc.save("barcode.pdf");

    case "uri":
      return doc.output('datauristring');

    case "printout":
      doc.autoPrint({ variant: 'non-conform' })
      return doc.output('dataurlnewwindow');
    // return doc.addJS('print({});');



    default:
      return doc.save("barcode.pdf");
  }


}
